import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { CtaSection } from './components/CtaSection';
import { Services } from './components/Services';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-crema font-sans text-dark selection:bg-eucalipto selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <CtaSection data-id="element-3" />
      <Services data-id="element-4" />
      <About data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Footer data-id="element-7" />
      <WhatsAppButton data-id="element-8" />
    </div>;
}